// extracted by mini-css-extract-plugin
export default {"wrapper":"introductionjackbox2_wrapper__ngldG","button":"introductionjackbox2_button__fTKxC"};